export enum RealizacijaEnum {
  UkupnaRealizacija = 'UkupnaRealizacija',
  RealizacijaUgovora = 'RealizacijaUgovora',
  RealizacijaKlijenta = 'RealizacijaKlijenta',
  RealizacijaPodugovora = 'RealizacijaPodugovora',
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/realizacija-ugovora/realizacija.enum.ts